import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { otherIncomeTypes } from 'src/app/@core/constants';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';


@Component({
  selector: 'app-others-income',
  templateUrl: './others-income.component.html',
  styleUrls: ['./others-income.component.sass']
})
export class OthersIncomeComponent implements OnInit {

  @Input() otherIncomeForm = new FormGroup({
    incomeType: new FormControl("", Validators.required),
    incomeAmount: new FormControl("", [Validators.min(1), Validators.required]),
    specify: new FormControl("", Validators.required),
    receivingDate: new FormControl("", Validators.required),
  })
  @Input() onbaseCatalogue = new OnbaseCatalogue();
  @Input() readonly: boolean = false;
  incomeTypes: Array<{ key: string, value: string }> = []
  @Input() isShortFormActiveForPlan = false;
  constructor() { }

  ngOnInit(): void {
    this.incomeTypes = otherIncomeTypes;

    this.otherIncomeForm.get("incomeType")?.markAsDirty();
  }

}
